import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import api from '../api';

function Settings() {
  const [passData, setPassData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  
  // State για Alert Settings
  const [alertData, setAlertData] = useState({
    smtpHost: '', smtpPort: 587, smtpUser: '', smtpPass: '',
    alertReceiverEmail: '', discordWebhookUrl: '',
    // per-device enables/delays moved to Devices -> Alerts modal
  });

  const [passMessage, setPassMessage] = useState(null);
  const [passError, setPassError] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertError, setAlertError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Φόρτωση ρυθμίσεων όταν ανοίγει η σελίδα
  useEffect(() => {
    // Φτιάξε αυτό το route στο backend αν δεν υπάρχει, ή φόρτωσέ τα από το user profile
    api.get('/api/auth/me').then(res => {
        if(res.data.client) {
          setAlertData({
            smtpHost: res.data.client.smtpHost || '',
            smtpPort: res.data.client.smtpPort || 587,
            smtpUser: res.data.client.smtpUser || '',
            smtpPass: '', // Για ασφάλεια συνήθως δεν το στέλνουμε πίσω
            alertReceiverEmail: res.data.client.alertReceiverEmail || '',
            discordWebhookUrl: res.data.client.discordWebhookUrl || ''
          });
        }
    }).catch(err => console.log(err));
  }, []);

  const handlePassSubmit = async (e) => {
    e.preventDefault();
    setPassError(null); setPassMessage(null);
    if (passData.newPassword !== passData.confirmPassword) return setPassError('Οι κωδικοί δεν ταιριάζουν');
    
    setLoading(true);
    try {
      await api.put('/api/auth/change-password', passData);
      setPassMessage('Ο κωδικός άλλαξε!');
      setPassData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) { setPassError(err.response?.data?.error || 'Σφάλμα'); } 
    finally { setLoading(false); }
  };

  const handleAlertSubmit = async (e) => {
    e.preventDefault();
    setAlertError(null); setAlertMessage(null);
    setLoading(true);
    try {
        // Θα χρειαστείς αυτό το route στο backend (π.χ. στο routes/auth.js ή clients.js)
        await api.put('/api/clients/me/settings', alertData); 
        setAlertMessage('Οι ρυθμίσεις ειδοποιήσεων αποθηκεύτηκαν!');
    } catch (err) { setAlertError(err.response?.data?.error || 'Σφάλμα αποθήκευσης ρυθμίσεων'); }
    finally { setLoading(false); }
  };

  return (
    <Container className="mt-4">
      <h2><i className="bi bi-gear-fill me-2"></i>Ρυθμίσεις</h2>
      
      {/* Κάρτα SMTP / Discord */}
      <Card className="mt-4 mb-4">
        <Card.Header>Ρυθμίσεις Ειδοποιήσεων (SMTP & Discord)</Card.Header>
        <Card.Body>
          {alertMessage && <Alert variant="success">{alertMessage}</Alert>}
          {alertError && <Alert variant="danger">{alertError}</Alert>}
            <Form onSubmit={handleAlertSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>SMTP Host</Form.Label>
                            <Form.Control type="text" value={alertData.smtpHost} onChange={e => setAlertData({...alertData, smtpHost: e.target.value})} placeholder="π.χ. smtp.gmail.com" />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>SMTP Port</Form.Label>
                            <Form.Control type="number" value={alertData.smtpPort} onChange={e => setAlertData({...alertData, smtpPort: e.target.value})} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>SMTP User (Email)</Form.Label>
                            <Form.Control type="email" value={alertData.smtpUser} onChange={e => setAlertData({...alertData, smtpUser: e.target.value})} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>SMTP Password</Form.Label>
                            <Form.Control type="password" value={alertData.smtpPass} onChange={e => setAlertData({...alertData, smtpPass: e.target.value})} placeholder="Αφήστε κενό αν δεν αλλάζει" />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className="mb-3">
                    <Form.Label>Email Παραλήπτη Ειδοποιήσεων</Form.Label>
                    <Form.Control type="email" value={alertData.alertReceiverEmail} onChange={e => setAlertData({...alertData, alertReceiverEmail: e.target.value})} />
                </Form.Group>
                <hr />
                <Form.Group className="mb-3">
                    <Form.Label>Discord Webhook URL</Form.Label>
                    <Form.Control type="text" value={alertData.discordWebhookUrl} onChange={e => setAlertData({...alertData, discordWebhookUrl: e.target.value})} placeholder="https://discord.com/api/webhooks/..." />
                </Form.Group>
                {/* Per-device enables/delays are managed per device in Devices -> Ρυθμίσεις Alerts */}
                <Button variant="success" type="submit" disabled={loading}>Αποθήκευση Ρυθμίσεων</Button>
            </Form>
        </Card.Body>
      </Card>

      {/* Κάρτα Κωδικού (Υπάρχουσα) */}
      <Card style={{ maxWidth: '500px' }}>
        <Card.Header>Αλλαγή Κωδικού Πρόσβασης</Card.Header>
        <Card.Body>
          {passMessage && <Alert variant="success">{passMessage}</Alert>}
          {passError && <Alert variant="danger">{passError}</Alert>}
          <Form onSubmit={handlePassSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Τρέχων Κωδικός</Form.Label>
                <Form.Control type="password" value={passData.currentPassword} onChange={(e) => setPassData({...passData, currentPassword: e.target.value})} required />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Νέος Κωδικός</Form.Label>
                <Form.Control type="password" value={passData.newPassword} onChange={(e) => setPassData({...passData, newPassword: e.target.value})} required />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Επιβεβαίωση</Form.Label>
                <Form.Control type="password" value={passData.confirmPassword} onChange={(e) => setPassData({...passData, confirmPassword: e.target.value})} required />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={loading}>Αλλαγή Κωδικού</Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Settings;